<div class="v2-page" [class.year-mode]="viewMode === 'year'" [class.monitor-planning]="monitorMode">

    <!-- Seitenkopf -->
    <header class="page-header" *ngIf="!monitorMode">
        <div *ngIf="viewMode !== 'year'">

            <h1>Mitarbeiterplanung</h1>

        </div>

        <div class="header-actions" *ngIf="viewMode !== 'year'">
            <button mat-flat-button color="primary" (click)="openNewAssignment()"
                [disabled]="loading && employees.length === 0">
                <mat-icon>add</mat-icon>
                Neuer Termin
            </button>
        </div>
    </header>


    <!-- Planung -->
    <section class="planning-card" [class.year-planning-card]="viewMode === 'year'">

        <!-- Filter, Datumsnavigation und Ansichtswechsel -->
        <div class="filter-toolbar" *ngIf="!monitorMode">

            <!-- LINKE SEITE: FILTER -->
            <div class="filter-toolbar-left">

                <!-- Teamwahl für globale Planer und Teamleiter -->
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="employee-filter"
                    *ngIf="selectableTeams.length > 0">
                    <mat-label>Planungsbereich</mat-label>
                    <mat-select [value]="selectedTeamId" (selectionChange)="onTeamSelectionChange($event.value)">
                        <mat-option *ngIf="isGlobalPlanner" [value]="null">Gesamtplanung (alle Mitarbeiter)</mat-option>
                        <mat-option *ngFor="let team of selectableTeams" [value]="team.teamId">Team {{ team.teamName
                            }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- Mitarbeiterfilter -->
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="employee-filter">

                    <mat-label>Mitarbeiter filtern</mat-label>

                    <mat-select multiple [value]="selectedEmployeeIds"
                        (selectionChange)="onEmployeeSelectionChange($event.value)">

                        <mat-select-trigger>
                            {{ employeeFilterLabel }}
                        </mat-select-trigger>

                        <mat-option *ngFor="let employee of planningEmployees" [value]="employee.id">
                            {{ employee.name }}
                        </mat-option>

                    </mat-select>
                </mat-form-field>


                <!-- Kenntnissefilter -->
                <mat-form-field appearance="outline" subscriptSizing="dynamic" *ngIf="viewMode !== 'year'"
                    class="knowledge-filter">

                    <mat-label>Kenntnisse filtern</mat-label>

                    <mat-select [(ngModel)]="selectedKnowledgeIds" multiple>

                        <mat-option *ngFor="let item of teamKnowledge" [value]="item.id">
                            {{ item.name }}
                        </mat-option>

                    </mat-select>
                </mat-form-field>


                <!-- Kategorienfilter: nur Jahresansicht -->
                <mat-form-field *ngIf="viewMode === 'year'" appearance="outline" subscriptSizing="dynamic"
                    class="year-category-filter">

                    <mat-label>Kategorien filtern</mat-label>

                    <mat-select multiple [value]="selectedYearCategoryIds"
                        (selectionChange)="onYearCategorySelectionChange($event.value)">

                        <mat-select-trigger>
                            {{ yearCategoryFilterLabel }}
                        </mat-select-trigger>

                        <mat-option *ngFor="let category of categories" [value]="category.id">
                            {{ category.name }}
                        </mat-option>

                    </mat-select>
                </mat-form-field>


                <!-- Ausgeblendete Outlook-Termine (Liste zum Wiederherstellen) -->
                <button mat-stroked-button type="button" class="hidden-events-btn" *ngIf="canHideExternal"
                    (click)="openHiddenExternalEventsDialog()"
                    matTooltip="Ausgeblendete Outlook-Termine anzeigen und wieder einblenden">
                    <mat-icon>visibility_off</mat-icon>
                    <span>Ausgeblendete Termine</span>
                    <span class="hidden-events-count" *ngIf="hiddenExternalCount > 0">
                        {{ hiddenExternalCount }}
                    </span>
                </button>

            </div>


            <!-- RECHTE SEITE: NAVIGATION + ANSICHT -->
            <div class="filter-toolbar-right">

                <!-- Datumsnavigation -->
                <div class="week-navigation">

                    <button mat-icon-button (click)="previousPeriod()" [attr.aria-label]="'Vorheriges ' + periodNoun">
                        <mat-icon>chevron_left</mat-icon>
                    </button>

                    <strong>{{ periodLabel }}</strong>

                    <button mat-icon-button (click)="nextPeriod()" [attr.aria-label]="'Nächstes ' + periodNoun">
                        <mat-icon>chevron_right</mat-icon>
                    </button>

                    <button mat-stroked-button (click)="goToToday()" *ngIf="viewMode !== 'year'">
                        Heute
                    </button>

                </div>


                <!-- Ansichtswechsel -->
                <div class="view-switch">

                    <button type="button" [class.active]="viewMode === 'week'" (click)="setViewMode('week')">
                        Woche
                    </button>

                    <button type="button" [class.active]="viewMode === 'month'" (click)="setViewMode('month')">
                        Monat
                    </button>

                    <button type="button" [class.active]="viewMode === 'quarter'" (click)="setViewMode('quarter')">
                        Quartal
                    </button>

                    <button type="button" [class.active]="viewMode === 'year'" (click)="setViewMode('year')">
                        Jahr
                    </button>

                </div>

            </div>

        </div>

        <!-- Timeline: --day-count steuert die Spaltenanzahl aller Tagesraster -->
        <div class="planning-loading" *ngIf="loading">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>

            <div class="planning-loading-text">
                Termine werden geladen ...
            </div>
        </div>

        <div #monitorTimelineScroll class="timeline-scroll" *ngIf="viewMode !== 'year'">
            <div class="timeline" [class.view-week]="viewMode === 'week'" [class.view-month]="viewMode === 'month'"
                [class.view-quarter]="viewMode === 'quarter'" [style.--day-count]="columnCount">

                <div class="timeline-header">
                    <div class="employee-header">MITARBEITER</div>

                    <div class="days-header">

                        <!-- Wochen- und Monatsansicht: einzelne Tage -->
                        <ng-container *ngIf="!isOverviewMode">
                            <div class="day-header" *ngFor="let day of days; trackBy: trackDay"
                                [class.weekend]="day.isWeekend" [class.today]="day.isToday">

                                <span>{{ day.label }}</span>
                                <strong>{{ day.date | date:'dd.MM' }}</strong>

                            </div>
                        </ng-container>

                        <!-- Quartals- und Jahresansicht -->
                        <ng-container *ngIf="isOverviewMode">
                            <div class="day-header period-header" *ngFor="let column of periodColumns"
                                [class.today]="column.isToday">

                                <strong>{{ column.label }}</strong>
                            </div>
                        </ng-container>

                    </div>
                </div>

                <div class="employee-row" *ngFor="let employee of visibleEmployees;
                      trackBy: trackEmployee">

                    <div class="employee-info">
                        <div class="avatar" [style.background-color]="employee.color">
                            {{ employee.initials }}
                        </div>

                        <div class="employee-text">
                            <strong>{{ employee.name }}</strong>
                            <div class="employee-skills">
                                <span *ngFor="let skill of getEmployeeSkills(employee)" class="skill-badge"
                                    [style.background-color]="skill.color || '#64748b'">
                                    {{ skill.name }}
                                </span>
                            </div>
                        </div>


                        <div class="employee-capacity">
                            <span class="load-badge" [class.overloaded]="getEmployeeOverloadedDays(employee) > 0"
                                [matTooltip]="
                                'Durchschnittliche Auslastung: ' +
                                getEmployeeLoad(employee) + '%'
                            ">
                                {{ getEmployeeLoad(employee) }} %
                            </span>

                            <span class="capacity-hours">
                                {{ getEmployeePlannedHours(employee) | number:'1.0-2' }}
                                /
                                {{ getEmployeeAvailableHours(employee) | number:'1.0-2' }}
                                h
                            </span>

                            <span class="overloaded-days" *ngIf="getEmployeeOverloadedDays(employee) > 0">
                                {{ getEmployeeOverloadedDays(employee) }}
                                {{ getEmployeeOverloadedDays(employee) === 1
                                ? 'Tag überlastet'
                                : 'Tage überlastet' }}
                            </span>
                        </div>

                    </div>



                    <!-- Interaktion: Pointer Events, Zustandsautomat in der Komponente.
                         data-employee-id wird beim Ziehen zur Zielzeile aufgelöst. -->
                    <div class="employee-calendar" [attr.data-employee-id]="employee.id"
                        [class.drop-target]="interactionActive && activeTargetEmployeeId === employee.id"
                        (pointerdown)="onCalendarPointerDown($event, employee.id)">

                        <!-- Hintergrundspalten -->
                        <div class="day-backgrounds">

                            <!-- Tagesansichten -->
                            <ng-container *ngIf="!isOverviewMode">
                                <div *ngFor="let day of days; trackBy: trackDay" [class.weekend]="day.isWeekend"
                                    [class.today]="day.isToday"
                                    [class.overloaded-day]="getDayLoad(employee, day.key) > 100">
                                </div>
                            </ng-container>

                            <!-- Quartals- und Jahresansicht -->
                            <ng-container *ngIf="isOverviewMode">
                                <div *ngFor="let column of periodColumns" [class.today]="column.isToday"
                                    [class.overloaded-day]="isPeriodOverloaded(employee, column)">
                                </div>
                            </ng-container>

                        </div>


                        <!-- Transparente Bereiche für die Tages-Tooltips -->
                        <div class="day-tooltips">


                            <!-- Wochen- und Monatsansicht -->
                            <ng-container *ngIf="!isOverviewMode">

                                <div class="capacity-tooltip-trigger" *ngFor="let day of days; trackBy: trackDay"
                                    cdkOverlayOrigin #tooltipOrigin="cdkOverlayOrigin"
                                    (mouseenter)="showCapacityTooltip(employee.id, day.key)"
                                    (mouseleave)="hideCapacityTooltip()">

                                    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="tooltipOrigin"
                                        [cdkConnectedOverlayOpen]="activeCapacityTooltip === employee.id + '_' + day.key"
                                        [cdkConnectedOverlayPositions]="capacityTooltipPositions"
                                        [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayViewportMargin]="12">

                                        <div class="capacity-custom-tooltip overlay-tooltip">

                                            <!-- Header -->
                                            <div class="capacity-tooltip-header">
                                                <mat-icon>calendar_today</mat-icon>

                                                <strong>
                                                    {{ day.date | date:'EEEE, dd.MM.yyyy':'':'de-AT' }}
                                                </strong>
                                            </div>

                                            <!-- Inhalt -->
                                            <div class="capacity-tooltip-body">

                                                <div class="capacity-tooltip-row">
                                                    <span>Geplant</span>
                                                    <strong>
                                                        {{ getDayCapacity(employee, day.key).plannedHours |
                                                        number:'1.0-2' }} h
                                                    </strong>
                                                </div>

                                                <div class="capacity-tooltip-row">
                                                    <span>Kapazität</span>
                                                    <strong>
                                                        {{ getDayCapacity(employee, day.key).availableHours |
                                                        number:'1.0-2' }} h
                                                    </strong>
                                                </div>

                                                <div class="capacity-tooltip-divider"></div>

                                                <div class="capacity-tooltip-row">
                                                    <span>Auslastung</span>

                                                    <strong
                                                        [class.capacity-value-overloaded]="getDayCapacity(employee, day.key).overloaded">
                                                        {{ getDayCapacity(employee, day.key).utilizationPercent |
                                                        number:'1.0-0' }} %
                                                    </strong>
                                                </div>

                                                <!-- Fortschrittsbalken -->
                                                <div class="capacity-tooltip-progress">
                                                    <div class="capacity-tooltip-progress-fill"
                                                        [class.overloaded]="getDayCapacity(employee, day.key).overloaded"
                                                        [style.width.%]="getCapacityProgress(employee, day.key)">
                                                    </div>
                                                </div>

                                                <!-- Status -->
                                                <div class="capacity-tooltip-status"
                                                    [class.overloaded]="getDayCapacity(employee, day.key).overloaded">

                                                    <mat-icon>
                                                        {{ getDayCapacity(employee, day.key).overloaded
                                                        ? 'warning_amber'
                                                        : 'check_circle_outline' }}
                                                    </mat-icon>

                                                    {{ getDayCapacity(employee, day.key).overloaded
                                                    ? 'Überlastung'
                                                    : 'Keine Überlastung' }}
                                                </div>

                                            </div>
                                        </div>

                                    </ng-template>

                                </div>

                            </ng-container>



                            <!-- Quartalsansicht -->
                            <ng-container *ngIf="viewMode === 'quarter'">

                                <div class="capacity-tooltip-trigger" *ngFor="let column of periodColumns"
                                    cdkOverlayOrigin #periodTooltipOrigin="cdkOverlayOrigin"
                                    (mouseenter)="showCapacityTooltip(employee.id, column.key)"
                                    (mouseleave)="hideCapacityTooltip()">

                                    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="periodTooltipOrigin"
                                        [cdkConnectedOverlayOpen]="activeCapacityTooltip === employee.id + '_' + column.key"
                                        [cdkConnectedOverlayPositions]="capacityTooltipPositions"
                                        [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayViewportMargin]="12">

                                        <div class="capacity-custom-tooltip overlay-tooltip">

                                            <div class="capacity-tooltip-header">
                                                <mat-icon>date_range</mat-icon>

                                                <strong>
                                                    {{ column.label }}
                                                </strong>
                                            </div>

                                            <div class="capacity-tooltip-body">

                                                <div class="capacity-tooltip-row">
                                                    <span>Zeitraum</span>
                                                    <strong>
                                                        {{ column.startDate | date:'dd.MM.yyyy' }}
                                                        –
                                                        {{ column.endDate | date:'dd.MM.yyyy' }}
                                                    </strong>
                                                </div>

                                                <div class="capacity-tooltip-divider"></div>

                                                <div class="capacity-tooltip-row">
                                                    <span>Geplant</span>
                                                    <strong>
                                                        {{ getPeriodCapacity(employee, column).plannedHours |
                                                        number:'1.0-2' }} h
                                                    </strong>
                                                </div>

                                                <div class="capacity-tooltip-row">
                                                    <span>Kapazität</span>
                                                    <strong>
                                                        {{ getPeriodCapacity(employee, column).availableHours |
                                                        number:'1.0-2' }} h
                                                    </strong>
                                                </div>

                                                <div class="capacity-tooltip-divider"></div>

                                                <div class="capacity-tooltip-row">
                                                    <span>Auslastung</span>

                                                    <strong
                                                        [class.capacity-value-overloaded]="getPeriodCapacity(employee, column).overloadedDays > 0">
                                                        {{ getPeriodCapacity(employee, column).utilizationPercent |
                                                        number:'1.0-0' }} %
                                                    </strong>
                                                </div>

                                                <div class="capacity-tooltip-progress">
                                                    <div class="capacity-tooltip-progress-fill"
                                                        [class.overloaded]="getPeriodCapacity(employee, column).overloadedDays > 0"
                                                        [style.width.%]="getPeriodCapacityProgress(employee, column)">
                                                    </div>
                                                </div>

                                                <div class="capacity-tooltip-status"
                                                    [class.overloaded]="getPeriodCapacity(employee, column).overloadedDays > 0">

                                                    <mat-icon>
                                                        {{ getPeriodCapacity(employee, column).overloadedDays > 0
                                                        ? 'warning_amber'
                                                        : 'check_circle_outline' }}
                                                    </mat-icon>

                                                    {{ getPeriodCapacity(employee, column).overloadedDays > 0
                                                    ? getPeriodCapacity(employee, column).overloadedDays + ' überlastete
                                                    Tage'
                                                    : 'Keine Überlastung' }}
                                                </div>

                                            </div>
                                        </div>

                                    </ng-template>

                                </div>

                            </ng-container>


                        </div>


                        <!-- Markierter Zeitraum -->
                        <div class="selection-grid" *ngIf="
                            !isOverviewMode &&
                            selectionActive &&
                            selectionEmployeeId === employee.id
                        ">

                            <div class="selection-highlight" [style.grid-column]="
                            getSelectionColumn() + ' / span ' + getSelectionSpan()
                            ">
                            </div>
                        </div>


                        <!-- Terminbalken -->
                        <div class="assignment-lanes">

                            <div class="assignment-bar" *ngFor="let bar of getBars(employee.id); trackBy: trackBar"
                                [class.external-event]="isExternalAssignment(bar.assignment)"
                                [class.absence-event]="isAbsenceAssignment(bar.assignment)"
                                [class.read-only-event]="isReadOnlyAssignment(bar.assignment) && !isAbsenceAssignment(bar.assignment)"
                                [class.narrow]="bar.columnSpan < 3" [class.single-column]="bar.columnSpan === 1"
                                [class.dragging]="isBarDragging(bar)"
                                [style.grid-column]="(bar.startColumn + 1) + ' / span ' + bar.columnSpan"
                                [style.grid-row]="bar.lane + 1" [style.background-color]="bar.assignment.color"
                                cdkOverlayOrigin #assignmentOrigin="cdkOverlayOrigin"
                                (mouseenter)="showAssignmentTooltip(bar.assignment.id, employee.id)"
                                (mouseleave)="hideAssignmentTooltip()"
                                (pointerdown)="onBarPointerDown($event, bar.assignment, employee.id, 'move')">

                                <!-- Linker Resize-Griff -->
                                <span class="resize-handle left" title="Beginn verschieben"
                                    *ngIf="!isLockedBar(bar.assignment)"
                                    (pointerdown)="onBarPointerDown($event, bar.assignment, employee.id, 'resize-start')">
                                </span>

                                <!-- Terminname -->
                                <span class="bar-title">
                                    {{ bar.assignment.title }}
                                </span>

                                <!-- Auslastung -->
                                <span class="bar-percent"
                                    *ngIf="!isExternalAssignment(bar.assignment) && !isAbsenceAssignment(bar.assignment)">
                                    {{ bar.utilizationPercent }} %
                                </span>

                                <!-- Outlook-Termin ausblenden (nur noch nicht übernommene Termine).
                                     pointerdown/mousedown werden gestoppt, damit weder der
                                     Übernahme-Editor noch eine Drag-Interaktion beginnt. -->
                                <button type="button" class="bar-hide-btn"
                                    *ngIf="isExternalAssignment(bar.assignment) && canHideExternal"
                                    matTooltip="Termin ausblenden" matTooltipShowDelay="300"
                                    aria-label="Termin ausblenden" [disabled]="isHidingExternal(bar.assignment)"
                                    (pointerdown)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()"
                                    (click)="hideExternalAssignment($event, bar.assignment)">
                                    <mat-icon>visibility_off</mat-icon>
                                </button>

                                <!-- Rechter Resize-Griff -->
                                <span class="resize-handle right" title="Ende verschieben"
                                    *ngIf="!isLockedBar(bar.assignment)"
                                    (pointerdown)="onBarPointerDown($event, bar.assignment, employee.id, 'resize-end')">
                                </span>

                                <!-- Tooltip über Angular CDK Overlay -->
                                <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="assignmentOrigin"
                                    [cdkConnectedOverlayOpen]="
                                        activeAssignmentTooltip === bar.assignment.id &&
                                        activeAssignmentTooltipEmployeeId === employee.id &&
                                        !interactionActive
                                    " [cdkConnectedOverlayPositions]="assignmentTooltipPositions"
                                    [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayViewportMargin]="12">

                                    <app-resource-assignment-tooltip
                                        [category]="isExternalAssignment(bar.assignment) ? 'Outlook-Termin' : isAbsenceAssignment(bar.assignment) ? 'Abwesenheit' : (bar.assignment.category || 'Termin')"
                                        [title]="bar.assignment.title" [startDate]="bar.assignment.startDate"
                                        [endDate]="bar.assignment.endDate" [startTime]="bar.assignment.startTime"
                                        [endTime]="bar.assignment.endTime"
                                        [utilizationPercent]="isExternalAssignment(bar.assignment) || isAbsenceAssignment(bar.assignment) ? null : bar.utilizationPercent"
                                        [location]="bar.assignment.location"
                                        [footerText]="tooltipFooter(bar.assignment)?.text ?? null"
                                        [footerIcon]="tooltipFooter(bar.assignment)?.icon ?? 'info_outline'">
                                    </app-resource-assignment-tooltip>

                                </ng-template>

                            </div>



                        </div>
                    </div>
                </div>

                <div class="empty-state" *ngIf="filteredEmployees.length === 0">
                    <mat-icon>{{ loading ? 'hourglass_empty' : 'person_search' }}</mat-icon>
                    <p *ngIf="loading">Daten werden geladen …</p>
                    <p *ngIf="!loading && employees.length === 0">
                        Keine Mitarbeiter vorhanden. Mitarbeiter erscheinen hier, sobald sie einem
                        Team zugeordnet sind (Verwaltung → Team &amp; Mitarbeiter).
                    </p>
                    <p *ngIf="!loading && employees.length > 0">Keine Mitarbeiter gefunden.</p>
                </div>

            </div>
        </div>
        <!-- ========================================
        JAHRESANSICHT
        ======================================== -->

        <!-- Monitor-Modus, Jahresansicht: Legende als halbtransparente Card neben dem Kalender.
             Seite nach aktuellem Monat und Jahresseite (monitorLegendSide); der Kalender hält den
             gemessenen Platz der Legende frei (monitorLegendReserve), sodass sie keine Balken verdeckt. -->
        <aside class="monitor-legend-card" #monitorLegendCard
            *ngIf="monitorMode && viewMode === 'year' && monitorLegend.employees.length"
            [class.side-left]="monitorLegendSide === 'left'" [class.side-right]="monitorLegendSide === 'right'"
            aria-label="Legende">
            <div class="monitor-legend-title">Mitarbeiter</div>
            <ul class="monitor-legend-employees" [class.two-columns]="monitorLegend.employees.length > 12">
                <li *ngFor="let e of monitorLegend.employees; trackBy: trackLegend">
                    <span class="monitor-legend-swatch" [style.backgroundColor]="e.color"></span>
                    <span class="monitor-legend-name">{{ e.name }}</span>
                </li>
            </ul>

            <!-- Füllart erklärt die Kategorie (immer sichtbar) -->
            <ng-container>
                <div class="monitor-legend-title">Darstellung</div>
                <ul class="monitor-legend-kinds">
                    <li>
                        <span class="monitor-legend-sample"></span>
                        <span>Termin</span>
                    </li>
                    <li>
                        <span class="monitor-legend-sample hatched"></span>
                        <span>Abwesenheit<small *ngIf="monitorLegend.absenceCategories.length">
                                ({{ monitorLegend.absenceCategories.join(', ') }})</small></span>
                    </li>
                </ul>
            </ng-container>
        </aside>

        <!-- Monitor: --year-month-count (6 oder 12) steuert die Spaltenanzahl, legend-left/right und
             --monitor-legend-reserve den freigehaltenen Legendenbereich. Normale Planung: unverändert. -->
        <div class="year-calendar-scroll" *ngIf="viewMode === 'year'"
            [class.legend-left]="monitorMode && monitorLegendSide === 'left'"
            [class.legend-right]="monitorMode && monitorLegendSide === 'right'">

            <div class="year-calendar" [style.--year-month-count]="monitorMode ? visibleYearMonths.length : null">

                <div class="year-month" *ngFor="let month of visibleYearMonths; trackBy: trackYearMonth">

                    <!-- Monatsüberschrift -->
                    <div class="year-month-header">
                        {{ month.label }}
                    </div>

                    <!-- Tage und Termine -->
                    <div class="year-month-body">

                        <!-- Tageszeilen -->
                        <div class="year-day" *ngFor="let day of month.days; trackBy: trackYearDay"
                            [class.weekend]="day.isWeekend" [class.today]="day.isToday">

                            <span class="year-day-number">
                                {{ day.dayNumber }}
                            </span>

                            <span class="year-day-weekday">
                                {{ day.weekday }}
                            </span>

                        </div>


                        <!-- Senkrechte Terminbalken -->
                        <div class="year-assignments">

                            <div class="year-assignment-bar"
                                *ngFor="let bar of getYearBars(month); trackBy: trackYearBar"
                                [ngStyle]="getYearBarStyle(bar)"
                                [class.external-event]="isExternalAssignment(bar.assignment)"
                                [class.absence-event]="isAbsenceAssignment(bar.assignment)"
                                [class.monitor-year-bar]="monitorMode" [class.monitor-absence]="!!bar.absence"
                                cdkOverlayOrigin #yearAssignmentOrigin="cdkOverlayOrigin"
                                (mouseenter)="showAssignmentTooltip(bar.assignment.id, bar.employeeId, month.monthIndex)"
                                (mouseleave)="hideAssignmentTooltip()"
                                (click)="$event.stopPropagation(); openAssignment(bar.assignment)"
                                (mousedown)="$event.stopPropagation()">

                                <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="yearAssignmentOrigin"
                                    [cdkConnectedOverlayOpen]="
                                        activeAssignmentTooltip === bar.assignment.id &&
                                        activeAssignmentTooltipEmployeeId === (bar.employeeId ?? null) &&
                                        activeYearTooltipMonth === month.monthIndex
                                    " [cdkConnectedOverlayPositions]="yearTooltipPositions"
                                    [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayViewportMargin]="12">

                                    <app-resource-assignment-tooltip [category]="bar.assignment.category || 'Termin'"
                                        [title]="bar.assignment.title" [startDate]="bar.assignment.startDate"
                                        [endDate]="bar.assignment.endDate" [startTime]="bar.assignment.startTime"
                                        [endTime]="bar.assignment.endTime" [alwaysShowRange]="true"
                                        [participants]="getYearParticipantNames(bar.assignment)"
                                        [location]="bar.assignment.location">
                                    </app-resource-assignment-tooltip>

                                </ng-template>

                            </div>

                        </div>


                    </div>

                </div>

            </div>

        </div>
        <!-- Legende -->
        <footer class="timeline-footer" *ngIf="!monitorMode">
            <span *ngFor="let category of categories; trackBy: trackCategory">
                <i class="legend-dot" [style.background-color]="category.color"></i> {{ category.name }}
            </span>
            <span class="footer-note" *ngIf="loading">
                Daten werden geladen …
            </span>
        </footer>

    </section>
</div>



<!-- Termin-Editor als Popup -->
<div class="v2-modal-overlay" *ngIf="!monitorMode && editorOpen && editingAssignment" (click)="closeEditor()">

    <div class="v2-modal-dialog" role="dialog" aria-modal="true" aria-label="Termin bearbeiten"
        (click)="$event.stopPropagation()">

        <app-resource-assignment-editor [assignment]="editingAssignment" [employees]="planningEmployees"
            [allAssignments]="assignments" [categories]="editorCategories" [saving]="saving"
            (saved)="saveAssignment($event)" (deleted)="deleteAssignment($event)" (closed)="closeEditor()"
            [customers]="customers" [plants]="plants">
        </app-resource-assignment-editor>

    </div>
</div>